export default "__VITE_ASSET__DKbU9KIo__"